export default __webpack_public_path__ + "static/media/Bb3.ac0f2d18.mp3";